import { IFilter } from '@pages/Products/Products';
import { format } from 'date-fns';
import { track } from '../utils';

export function trackInventorySearch(
  studioName: string,
  resultsFound: boolean,
  searchTerm?: string,
  filter?: IFilter,
) {
  const filterFinal: any = {
    Studio: studioName,
    'Results found': resultsFound,
  };

  if (searchTerm) {
    filterFinal['Search Criteria'] = searchTerm;
  }

  if (filter) {
    if (filter.sort && filter.direction) {
      filterFinal.Sort = filter.sort;
      filterFinal.Direction = filter.direction;
    }

    if (filter.startDate) {
      filterFinal['Start Date'] = format(filter.startDate, 'MM/dd/yyyy');
    }

    if (filter.endDate) {
      filterFinal['End Date'] = format(filter.endDate, 'MM/dd/yyyy');
    }

    if (filter.manufactorNames.length > 0) {
      const filteredManufacturers = filter.manufactorNames.filter(
        item => item.active,
      );
      if (filteredManufacturers.length > 0) {
        filterFinal.Manufacturers = filteredManufacturers.map(
          item => item.name,
        );
      }
    }

    if (filter.modelsName.length > 0) {
      const filteredModels = filter.modelsName.filter(item => item.active);
      if (filteredModels.length > 0) {
        filterFinal.Models = filteredModels.map(item => item.name);
      }
    }

    if (filter.status.length > 0) {
      const filteredStatus = filter.status.filter(item => item.active);
      if (filteredStatus.length > 0) {
        filterFinal.Status = filteredStatus.map(item => item.status.name);
      }
    }

    if (filter.tags.length > 0) {
      filterFinal.Tags = filter.tags.map(item => item.name);
    }

    if (filter.users.length > 0) {
      const filteredUsers = filter.users.filter(item => item.active);
      if (filteredUsers.length > 0) {
        filterFinal.Assignees = filteredUsers.map(item => item.user.name);
      }
    }
  }

  track('Inventory Search', filterFinal);
}

export function trackInventoryFieldsConfiguration(
  userEmail: string,
  studioName: string,
  columns: Array<string | undefined>,
) {
  track('Inventory Fields Configuration', {
    Studio: studioName,
    Email: userEmail,
    Columns: columns,
  });
}
